<div class="bg-workspace min-vh-100">
  <top-bar [title]="'Subscriptions'"></top-bar>
  <div class="container py-4 px-md-5">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" aria-current="page">
          <a href="/" routerLink="/school/{{ schoolId }}/dashboard">Home</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Subscriptions</li>
      </ol>
    </nav>

    <div class="card mb-4">
      <form class="card-header row gy-2 gy-md-4 gx-3">
        <div class="col-12 col-sm-5 col-lg-3">
          <app-month-picker
            [label]="'Billing month'"
            [value]="month"
            (valueChange)="month = $event; load()"
          ></app-month-picker>
        </div>
      </form>
      <div class="card-body">
        <div *ngIf="loading" class="d-flex py-4">
          <div class="spinner-border text-primary mx-auto" role="status" aria-hidden="true"></div>
        </div>
        <span *ngIf="!loading && !report">
          No billable subscription events recorded for {{ month }}.
        </span>
        <div *ngIf="!loading && report" class="table-responsive">
          <table class="table table-sm">
            <tbody class="table-body">
              <tr class="table-row"><td>Student registrations - new</td><td class="text-end">{{ report.newStudentRegistrations }}</td></tr>
              <tr class="table-row"><td>Student registrations - manual renewals</td><td class="text-end">{{ report.manualRenewedStudentRegistrations }}</td></tr>
              <tr class="table-row"><td>Student registrations - automatic renewals</td><td class="text-end">{{ report.automaticRenewedStudentRegistrations }}</td></tr>
              <tr class="table-row fw-bold"><td>Student registrations - payable</td><td class="text-end">{{ report.payableStudentRegistrations }}</td></tr>
              <tr class="table-row"><td>Teacher registrations - new</td><td class="text-end">{{ report.newTeacherRegistrations }}</td></tr>
              <tr class="table-row"><td>Teacher registrations - manual renewals</td><td class="text-end">{{ report.manualRenewedTeacherRegistrations }}</td></tr>
              <tr class="table-row"><td>Teacher registrations - automatic renewals</td><td class="text-end">{{ report.automaticRenewedTeacherRegistrations }}</td></tr>
              <tr class="table-row fw-bold"><td>Teacher registrations - payable</td><td class="text-end">{{ report.payableTeacherRegistrations }}</td></tr>
              <tr class="table-row"><td>Teacher subscriptions - new</td><td class="text-end">{{ report.newTeacherSubscriptions }}</td></tr>
              <tr class="table-row"><td>Teacher subscriptions - manual renewals</td><td class="text-end">{{ report.manualRenewedTeacherSubscriptions }}</td></tr>
              <tr class="table-row"><td>Teacher subscriptions - automatic renewals</td><td class="text-end">{{ report.automaticRenewedTeacherSubscriptions }}</td></tr>
              <tr class="table-row fw-bold"><td>Teacher subscriptions - payable</td><td class="text-end">{{ report.payableTeacherSubscriptions }}</td></tr>
              <tr class="table-row fw-bold"><td>Payable students</td><td class="text-end">{{ report.payableStudents }}</td></tr>
              <tr class="table-row fw-bold"><td>Payable teachers</td><td class="text-end">{{ report.payableTeachers }}</td></tr>
              <tr class="table-row"><td>Stopped during the month</td><td class="text-end">{{ report.stoppedSubscriptions }}</td></tr>
              <tr class="table-row"><td>Expired during the month</td><td class="text-end">{{ report.expiredSubscriptions }}</td></tr>
              <tr class="table-row fw-bold"><td>Total to pay for</td><td class="text-end">{{ report.totalPayable }}</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <app-school-subscriptions-list
      *ngIf="schoolId"
      class="d-block mb-4"
      [schoolId]="schoolId"
    ></app-school-subscriptions-list>

    <div class="card">
      <div class="card-header">
        <div>
          <h4 class="mb-0">Audit</h4>
          <span class="text-muted small">All subscription events recorded for {{ month }}</span>
        </div>
        <app-paginator
          class="ms-auto my-auto"
          [data]="auditPage"
          [pageable]="auditPageable"
          (newPage)="switchAuditPage($event)"
        ></app-paginator>
        <button
          *ngIf="auditPage?.content?.length"
          class="btn btn-primary rounded-pill ms-3 my-auto text-nowrap px-3 py-2"
          type="button"
          (click)="exportAudit()"
        >
          Download as .xlsx
        </button>
      </div>
      <div class="card-body">
        <span *ngIf="!loading && !auditPage?.content?.length">
          No subscription events recorded for {{ month }}.
        </span>
        <div *ngIf="!loading && auditPage?.content?.length" class="table-responsive">
          <table class="table table-sm">
            <thead>
              <tr class="table-row table-row-head text-nowrap">
                <th>Person</th>
                <th>Product</th>
                <th>Event</th>
                <th>Source</th>
                <th>Billing month</th>
                <th>Effective date</th>
                <th>Status</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr *ngFor="let event of auditPage.content" class="table-row">
                <td class="text-nowrap">{{ personName(event.person) }}</td>
                <td class="text-nowrap">{{ productLabel(event.productType) }}</td>
                <td>
                  <span
                    class="text-uppercase badge xsmall rounded-2 w-fit-content"
                    [ngClass]="eventBadgeClass(event)"
                  >
                    {{ eventLabel(event) }}
                  </span>
                </td>
                <td class="text-lowercase">{{ event.eventSource }}</td>
                <td>{{ event.billingMonth }}</td>
                <td class="text-nowrap">{{ event.effectiveDate | date : 'd/MM/yyyy' }}</td>
                <td>{{ event.subscriptionStatus }}</td>
                <td>{{ event.notes }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
